import { SYSTEM_URL } from '../constants';
import styles from './Footer.module.css';

export default function Footer({ accent }) {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <span className={styles.copy}>
        © {year} Glory's Boutique — Santa Rosa del Peñón, León, Nicaragua
      </span>
      <a
        href={SYSTEM_URL}
        className={styles.link}
        style={{ color: accent, transition: 'color 0.5s ease' }}
        target="_blank"
        rel="noopener noreferrer"
      >
        Ir al sistema →
      </a>
    </footer>
  );
}
